import * as React from 'react';
import { SVGProps } from 'react';

const IconMoleculesSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M11 4c0 .762-.284 1.458-.752 1.987L12.478 10h.022a2.5 2.5 0 1 1-1.854.822L8.5 6.96a3.02 3.02 0 0 1-1 0l-2.146 3.864A2.5 2.5 0 1 1 3.523 10l2.23-4.014A3 3 0 1 1 11 4z" />
  </svg>
);
export default IconMoleculesSizeS;
